import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { User, Phone } from "lucide-react";
import type { QuoteWizardState } from "../DoorKnockerQuickQuote";

interface Props {
  state: QuoteWizardState;
  setState: React.Dispatch<React.SetStateAction<QuoteWizardState>>;
  onNext: () => void;
}

export function StepCustomer({ state, setState, onNext }: Props) {
  return (
    <div className="px-5 pt-6 pb-8 space-y-6">
      <div>
        <div className="text-xs font-semibold text-primary uppercase tracking-wider mb-1.5">Step 2 / 4</div>
        <h2 className="text-2xl font-bold tracking-tight">Who's the homeowner?</h2>
        <p className="text-sm text-muted-foreground mt-1">Just the basics — phone is optional.</p>
      </div>

      <div className="rounded-2xl border border-border/60 bg-card p-4 space-y-4">
        <div className="space-y-2">
          <label className="text-xs font-semibold text-muted-foreground flex items-center gap-1.5">
            <User className="h-3.5 w-3.5" /> Customer Name
          </label>
          <Input
            value={state.name}
            onChange={(e) => setState((s) => ({ ...s, name: e.target.value }))}
            placeholder="John Smith"
            className="h-12 text-base"
            autoFocus
          />
        </div>

        <div className="space-y-2">
          <label className="text-xs font-semibold text-muted-foreground flex items-center gap-1.5">
            <Phone className="h-3.5 w-3.5" /> Phone <span className="text-muted-foreground/60 font-normal normal-case">(optional)</span>
          </label>
          <Input
            type="tel"
            inputMode="tel"
            value={state.phone}
            onChange={(e) => setState((s) => ({ ...s, phone: e.target.value }))}
            placeholder="(555) 123-4567"
            className="h-12 text-base"
          />
        </div>
      </div>

      <div className="rounded-2xl border border-border/60 bg-muted/20 p-4 space-y-3">
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Lead Preview</div>
        <div className="space-y-1.5 text-sm">
          <div className="flex items-center justify-between gap-4">
            <span className="text-muted-foreground">Homeowner</span>
            <span className="font-semibold text-right break-words">{state.name.trim() || "—"}</span>
          </div>
          <div className="flex items-center justify-between gap-4">
            <span className="text-muted-foreground">Phone</span>
            <span className="font-semibold text-right break-words">{state.phone.trim() || "Not added"}</span>
          </div>
          <div className="flex items-start justify-between gap-4">
            <span className="text-muted-foreground">Property</span>
            <span className="font-semibold text-right break-words max-w-[70%]">{state.address.trim() || "—"}</span>
          </div>
        </div>
      </div>

      <Button
        onClick={onNext}
        disabled={!state.name.trim()}
        className="w-full h-12 text-base font-semibold"
        size="lg"
      >
        Continue to Quote
      </Button>
    </div>
  );
}
